module.exports = __webpack_public_path__ + "img/jc-go.bf8fff35.png";